(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["velise-photo-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('velise-photo-carousel')) {
    customElements.define('velise-photo-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.vsl-gallery__track');
        this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
        this.index = 0;
        this.querySelector('.vsl-gallery__controls').hidden = this.dots.length < 2;
        this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-gallery-next]').addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
        this.track.addEventListener('scroll', () => {
          if (!this.track.clientWidth) return;
          this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.dots.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.resize = new ResizeObserver(() => this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' }));
        this.resize.observe(this.track);
      }
      go(index) {
        this.index = (index + this.dots.length) % this.dots.length;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
